export default __webpack_public_path__ + "file/Fiche-FR-Produit-Puroak-Copeaux.asset.2183b53d.pdf";